"use client";
import { jsxs as r, jsx as l } from "react/jsx-runtime";
const c = ({
  title: i,
  titleId: e,
  desc: a,
  descId: t,
  ...d
}) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icons-kr",
    viewBox: "0 0 640 480",
    "aria-labelledby": e,
    "aria-describedby": t,
    ...d,
    children: [
      a ? /* @__PURE__ */ l("desc", { id: t, children: a }) : null,
      i ? /* @__PURE__ */ l("title", { id: e, children: i }) : null,
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "kr-a", children: /* @__PURE__ */ l("path", { fillOpacity: 0.7, d: "M-95.8-.4h682.7v512H-95.8z" }) }) }),
      /* @__PURE__ */ r(
        "g",
        {
          fillRule: "evenodd",
          clipPath: "url(#kr-a)",
          transform: "translate(89.8 .4)scale(.9375)",
          children: [
            /* @__PURE__ */ l("path", { fill: "#fff", d: "M-95.8-.4H587v512H-95.8Z" }),
            /* @__PURE__ */ r("g", { transform: "rotate(-56.3 361.6 -101.3)scale(10.66667)", children: [
              /* @__PURE__ */ r("g", { id: "kr-c", children: [
                /* @__PURE__ */ l(
                  "path",
                  {
                    id: "kr-b",
                    fill: "#000001",
                    d: "M-6-26H6v2H-6Zm0 3H6v2H-6Zm0 3H6v2H-6Z"
                  }
                ),
                /* @__PURE__ */ l("use", { xlinkHref: "#kr-b", width: "100%", height: "100%", y: 44 })
              ] }),
              /* @__PURE__ */ l("path", { stroke: "#fff", d: "M0 17v10" }),
              /* @__PURE__ */ l("path", { fill: "#cd2e3a", d: "M0-12a12 12 0 0 1 0 24Z" }),
              /* @__PURE__ */ l("path", { fill: "#0047a0", d: "M0-12a12 12 0 0 0 0 24A6 6 0 0 0 0 0Z" }),
              /* @__PURE__ */ l("circle", { cy: -6, r: 6, fill: "#cd2e3a" })
            ] }),
            /* @__PURE__ */ r("g", { transform: "rotate(-123.7 191.2 62.2)scale(10.66667)", children: [
              /* @__PURE__ */ l("use", { xlinkHref: "#kr-c", width: "100%", height: "100%" }),
              /* @__PURE__ */ l("path", { stroke: "#fff", d: "M0-23.5v3M0 17v3.5m0 3v3" })
            ] })
          ]
        }
      )
    ]
  }
);
export {
  c as default
};
